import { Injectable } from '@angular/core';
import { createWarning } from '@core/helpers/create-validator.helper';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../../store/revisione53.reducers';
import { toNum } from '@shared/helpers/math.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';

@Injectable()
export class SchedaCoopSocialiWarningsFormService {
    constructor(private readonly store: Store<Revisione53State>) {}

    ammetterePersoneGiuridiche = createWarning(this.store, (myVerbale) => {
        const my_TipoSezEnte = myVerbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_TipoSezEnte;
        const my_CkAmmessiSociFinanz = myVerbale.my_SezioneI__Rilevazione.my_SchedaCoopSociali.my_CkAmmessiSociFinanz;
        const my_SociGiuCoopData = toNum(myVerbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale.my_SociGiuCoopData);

        if (!(my_TipoSezEnte !== '2' || my_CkAmmessiSociFinanz !== '0' || my_SociGiuCoopData <= 0)) {
            return " Nelle cooperative sociali è possibile ammettere, ai sensi dell'art.11 della L.381/91, persone giuridiche pubbliche o private, a condizione che nel loro statuto sia previsto il finanziamento o lo sviluppo delle attività di tali cooperative";
        } else {
            return null;
        }
    });

    my_PercentSociVolont = createWarning(this.store, (myVerbale) => {
        const percent = toNum(myVerbale.my_SezioneI__Rilevazione.my_SchedaCoopSociali.my_PercentSociVolont);

        if (percent > 0.5 && percent <= 1) {
            return 'Il numero di soci volontari costituisce più della metà del numero complessivo di soci. Occorre irrogare la diffida';
        } else {
            return null;
        }
    });

    my_PercentPersSvantagg = createWarning(this.store, (myVerbale) => {
        const soc = myVerbale.my_SezioneI__Rilevazione.my_SchedaCoopSociali;
        const ebs = myVerbale.my_SezioneI__Rilevazione.my_EffettivitaBaseSociale;
        const warning = myVerbale.my_Warning.my_ElWarning[4]; // IdWarning=5: diffida <30% persone svantaggiate

        if (warning.my_VisibWarning === '' || soc.my_ScSocObbl !== '1') {
            return;
        }

        const hasCategoria = soc.my_CkAgricolo === '1' || soc.my_CkIndustr === '1' || soc.my_CkComm === '1' || soc.my_CkServiz === '1';

        if (!hasCategoria) {
            return;
        }

        const percent = toNum(soc.my_PercentPersSvantagg);
        if (isNilOrEmpty(soc.my_PercentPersSvantagg) || isNaN(percent) || percent >= 0.3) {
            return;
        }

        const totLav = toNum(soc.my_TotLavoratori);
        const unitSoci = toNum(ebs.my_UnitaSociUtil);
        const unitNonSoci = toNum(ebs.my_UnitaNonSociUtil);

        if (isNaN(totLav) && isNaN(unitSoci) && isNaN(unitNonSoci)) {
            return;
        }

        if (Math.round(totLav) === Math.round(unitSoci) + Math.round(unitNonSoci)) {
            return 'Il numero di persone svantaggiate costituisce meno del 30% del numero di lavoratori. Occorre irrogare la diffida.';
        }
    });
}
